<nav class="sidebar" [class.collapsed]="layoutService.isCollapsed$ | async">
  <header>
    <div class="image-text">
      <span class="image">
        <a href="../create-resources">
          <img src="./assets/images/Bernie.png" alt="Bernie Logo" />
        </a>
      </span>
      <div class="text header-text">
        <a href="../create-resources" class="header-link">
          <span class="name">Bernie RDM</span>
          <span class="role">Resource Delivery Manager</span>
        </a>
      </div>
    </div>
    <i class="icon toggle" (click)="toggleSidebar()">
      <div class="svg-wrapper">
        <img
          src="../../../assets/icons/Arrow-Right-1--Streamline-Ultimate.svg"
        />
      </div>
    </i>
  </header>

  <div class="menu-bar">
    <div class="menu">
      <!--
      <li *ngIf="authService.isUser() || authService.isAdmin()" class="search-box" (click)="expandSidebar()">
        <img class="nav-icon" src="../../assets/icons/Search--Streamline-Ultimate.svg">
        <input class="text" type="text" placeholder="Search..." >
      </li>
      -->
      <ul class="menu-links">
        <!--
        <li class="nav-link">
          <a routerLink="/home" routerLinkActive="selected">
            <img class="nav-icon" src="../../assets/icons/House-Chimney-2--Streamline-Ultimate.svg">
            <span class="text nav-text">Home</span>
          </a>
        </li>
        -->

        @if (
          authService.isStaff() || authService.isStud() || authService.isAdmin()
        ) {
          <li class="nav-link">
            <a routerLink="/create-resources" routerLinkActive="selected">
              <img
                class="nav-icon"
                src="../../assets/icons/Plus-Math-Symbol-Circle--Streamline-Ultimate.svg"
              />
              <span class="text nav-text">{{
                'Microsoft 365' | translate
              }}</span>
            </a>
          </li>
        }

        @if (authService.isStaff() || authService.isAdmin()) {
          <li class="nav-link">
            <a routerLink="/server" routerLinkActive="selected">
              <img
                class="nav-icon"
                src="../../assets/icons/Plus-Math-Symbol-Circle--Streamline-Ultimate.svg"
              />
              <span class="text nav-text">{{ 'Server' | translate }}</span>
            </a>
          </li>
        }

        @if (
          authService.isStaff() || authService.isStud() || authService.isAdmin()
        ) {
          <li class="nav-link">
            <a routerLink="/my-resources" routerLinkActive="selected">
              <img
                class="nav-icon"
                src="../../assets/icons/Drawer-File--Streamline-Ultimate.svg"
              />
              <span class="text nav-text">{{
                'My Resources' | translate
              }}</span>
            </a>
          </li>
        }
        @if (authService.isStaff() || authService.isAdmin()) {
          <li class="nav-link">
            <a routerLink="/all-resources" routerLinkActive="selected">
              <img
                class="nav-icon"
                src="../../assets/icons/Archive-Drawer-Table--Streamline-Ultimate.svg"
              />
              <span class="text nav-text">{{
                'All Resources' | translate
              }}</span>
            </a>
          </li>
        }
        <!--
        <li *ngIf="authService.isUser() || authService.isAdmin()" class="nav-link">
          <a routerLink="/telephony" routerLinkActive="selected">
            <img class="nav-icon" src="../../assets/icons/Phone--Streamline-Ultimate.svg">
            <span class="text nav-text">Telephony</span>
          </a>
        </li>
        <li *ngIf="authService.isUser() || authService.isAdmin()" class="nav-link">
          <a routerLink="/settings" routerLinkActive="selected">
            <img class="nav-icon" src="../../assets/icons/Cog--Streamline-Ultimate.svg">
            <span class="text nav-text">Settings</span>
          </a>
        </li>
        -->
        @if (authService.isAdmin()) {
          <li class="nav-link">
            <a routerLink="/admin" routerLinkActive="selected">
              <img
                class="nav-icon"
                src="../../assets/icons/Cog--Streamline-Ultimate.svg"
              />
              <span class="text nav-text">{{
                'Admin' | translate
              }}</span>
            </a>
          </li>
        }
      </ul>
    </div>

    <div class="bottom-content">
      <ul>
        <li>
          <div class="full-width">
            <button
              mat-button
              [matMenuTriggerFor]="userMenu"
              class="user-button"
            >
              <div class="button-content">
                <img
                  class="nav-icon"
                  src="../../assets/icons/Single-Neutral-2--Streamline-Ultimate.svg"
                />
                <span class="text">{{
                  (authService.displayName$ | async) ?? 'Anonymous User'
                    | translate
                }}</span>
                <mat-icon class="dropdown-icon">expand_more</mat-icon>
              </div>
            </button>
            <mat-menu #userMenu="matMenu">
              @if (authService.isLoggedIn$ | async) {
                <button mat-menu-item class="menu-item">
                  <a href="#" (click)="logout()" class="menu-link">
                    <img
                      class="nav-icon-dropdown"
                      src="../../assets/icons/Logout-1--Streamline-Ultimate.svg"
                    />
                    <span class="text nav-text">Logout</span>
                  </a>
                </button>
              } @else {
                <button mat-menu-item class="menu-item">
                  <a href="#" (click)="login()" class="menu-link">
                    <img
                      class="nav-icon-dropdown"
                      src="../../assets/icons/Login-1--Streamline-Ultimate.svg"
                    />
                    <span class="text nav-text">Login</span>
                  </a>
                </button>
              }
            </mat-menu>
          </div>
        </li>
        <li>
          <div class="full-width">
            <button
              mat-button
              [matMenuTriggerFor]="langMenu"
              class="user-button"
            >
              <div class="button-content">
                <img
                  class="nav-icon"
                  src="../../assets/icons/Earth-3--Streamline-Ultimate.svg"
                />
                <span class="text">{{ activeLanguage | uppercase }}</span>
                <mat-icon class="dropdown-icon">expand_more</mat-icon>
              </div>
            </button>
            <mat-menu #langMenu="matMenu">
              @for (language of remainingLanguages; track $index) {
                <button
                  mat-menu-item
                  (click)="changeLanguage(language)"
                  class="language-menu-item"
                >
                  {{ language | uppercase }}
                </button>
              }
            </mat-menu>
          </div>
        </li>
        <li>
          @if (authService.isLoggedIn$ | async) {
            <div class="full-width">
              <button
                mat-button
                [matMenuTriggerFor]="infoMenu"
                class="user-button"
              >
                <div class="button-content">
                  <img
                    class="nav-icon"
                    src="../../assets/icons/Information-Circle--Streamline-Ultimate.svg"
                  />
                  <span class="text">{{ 'Information' | translate }}</span>
                  <mat-icon class="dropdown-icon">expand_more</mat-icon>
                </div>
              </button>
              <mat-menu #infoMenu="matMenu">
                <button mat-menu-item class="menu-item">
                  <a
                    href="#"
                    class="menu-link"
                    (click)="openUrlLocalized($event)"
                  >
                    <span class="text nav-text">{{
                      'Instructions' | translate
                    }}</span>
                  </a>
                </button>
                <button mat-menu-item class="menu-item">
                  <a href="#" class="menu-link" (click)="openForm($event)">
                    <span class="text nav-text">{{
                      'Feedback' | translate
                    }}</span>
                  </a>
                </button>

                <div class="menu-item non-clickable">
                  <div class="menu-link">
                    <span class="text nav-text non-clickable"
                      >{{ 'Frontend Version' | translate }} -
                      {{ version }}</span
                    >
                  </div>
                </div>

                @if (backendVersion) {
                  <div class="menu-item non-clickable">
                    <div class="menu-link">
                      <span class="text nav-text non-clickable"
                        >{{ 'Backend Version' | translate }} -
                        {{ backendVersion }}</span
                      >
                    </div>
                  </div>
                }
              </mat-menu>
            </div>
          }
        </li>
        <li class="mode">
          <div class="moon-sun">
            <img
              class="nav-icon moon"
              src="../../assets/icons/Do-Not-Disturb-Sleep-Mode--Streamline-Ultimate.svg"
            />
            <img
              class="nav-icon sun"
              src="../../assets/icons/Weather-Sun--Streamline-Ultimate.svg"
            />
          </div>

          <span class="mode-text text"></span>

          <div class="toggle-switch" (click)="toggleDarkMode()">
            <span class="switch"> </span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>
